import { render, staticRenderFns } from "./checkArea.vue?vue&type=template&id=188ccc28&scoped=true"
import script from "./checkArea.vue?vue&type=script&lang=js"
export * from "./checkArea.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/enroll/checkArea.css?vue&type=style&index=0&id=188ccc28&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ccc28",
  null
  
)

export default component.exports